import Vue from 'vue'
import Router from 'vue-router'
//商品分类列表
import Product_Center from './views/product_center/product_center.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  // mode: 'hash',
  saveScrollPosition: true,
  // base: process.env.BASE_URL,
  base:'/h5/',
  routes: [
    {
      path: '/',
      name: '/',
      component: Product_Center,
      meta: {
        title: '科普列表'
      }
    },
    //产品中心首页
    {
      path: '/index',
      name: 'index',
      component: Product_Center,
      meta: {
        title: '科普介绍'
      }
    },
    //产品中心首页
    {
      path: '/product_center',
      name:'product_center',
      component: Product_Center,
      meta: {
        title: '科普列表'
      }
    },
    //产品详情
    {
      path: '/detail',
      name:'detail',
      component: () => import('./views/detail/detail.vue'),
      meta: {
        title: '科普介绍'
      }
    },
    // 确认订单
    {
      path: '/detail/sure_order',
      name: 'sure_order',
      component: () => import('./views/detail/sure_order/sure_order.vue'),
      meta: {
        title: '确认订单'
      }
    },
    // 支付
    {
      path: '/pay',
      name: 'pay',
      component: () => import('./views/pay/pay.vue'),
      meta: {
        title: '选择支付方式'
      }
    },
    // 支付宝支付
    {
      path: '/alipay',
      name: 'alipay',
      component: () => import('./views/pay/alipay/alipay.vue'),
      meta: {
        title: '支付宝支付'
      }
    },
    // 支付宝支付成功
    {
      path: '/alipay/alipay_success',
      name: 'alipay_success',
      component: () => import('./views/pay/alipay_success/alipay_success.vue'),
      meta: {
        title: '支付成功'
      }
    },
    // 登录
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login/login.vue'),
      meta: {
        title: '登录'
      }
    },
    // 地址列表
    {
      path: '/address',
      name: 'address',
      component: () => import('./views/address/address.vue'),
      meta: {
        title: '我的地址'
      }
    },
    // 新增&编辑地址
    {
      path: '/address/add',
      name: 'addAddress',
      component: () => import('./views/address/add/add.vue'),
      meta: {
        title: '编辑地址'
      }
    },
    // 个人中心
    {
      path: '/my',
      name: 'my',
      component: () => import('./views/my/my.vue'),
      meta: {
        title: '个人中心'
      }
    },
    // 我的订单
    {
      path: '/order',
      name: 'order',
      component: () => import('./views/order/order.vue'),
      meta: {
        title: '我的订单'
      }
    },
    // 订单详情
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: () => import('./views/order/orderDetail/orderDetail.vue'),
      meta: {
        title: '订单详情'
      }
    },
    //订单详情
    {
      path: '/orderDetailTwo',
      name: 'orderDetailTwo',
      component: () => import('./views/order/orderDetail/orderDetailTwo.vue'),
      meta: {
        title: '订单详情'
      }
    },
    //订单评价
    {
      path: '/order/order_evaluate',
      name: 'order_evaluate',
      component: () => import('./views/order/order_evaluate/order_evaluate.vue'),
      meta: {
        title: '订单评价'
      }
    },
    //添加回寄
    {
      path: '/order/order_sentback',
      name: 'order_sentback',
      component: () => import('./views/order/order_sentback/order_sentback.vue'),
      meta: {
        title: '添加回寄'
      }
    },
     //退款
     {
      path: '/order/order_refund',
      name: 'order_refund',
      component: () => import('./views/order/order_refund/order_refund.vue'),
      meta: {
        title: '退款'
      }
    },
     //订单退款撤回
     {
      path: '/order/order_refund_back',
      name: 'order_refund_back',
      component: () => import('./views/order/order_refund_back/order_refund_back.vue'),
      meta: {
        title: '撤销退款'
      }
    },
     //订单退款成功
     {
      path: '/order/order_refund_success',
      name: 'order_refund_success',
      component: () => import('./views/order/order_refund_success/order_refund_success.vue'),
      meta: {
        title: '退款成功'
      }
    },

    //修改地址
    {
      path: '/my/user_change_address',
      name: 'user_change_address',
      component: () => import('./views/user/user_change_address/user_change_address.vue'),
      meta: {
        title: '修改地址'
      }
    },
	//检测报告
    {
      path: '/my/user_report_list',
      name: 'user_report_list',
      component: () => import('./views/user/user_report_list/user_report_list.vue'),
      meta: {
        title: '检测报告'
      }
    },
    //报告详情
    {
      path: '/my/user_report_detailed',
      name: 'user_report_detailed',
      component: () => import('./views/user/user_report_detailed/user_report_detailed.vue'),
      meta: {
        title: '报告详情'
      }
    },
    //申请发票
    {
      path: '/my/user_invoice',
      name: 'user_invoice',
      component: () => import('./views/user/user_invoice/user_invoice.vue'),
      meta: {
        title: '申请发票'
      }
    },
    //知情同意书
    {
      path: '/letter/letter',
      name: 'letter',
      component: () => import('./views/letter/letter.vue'),
      meta: {
        title: '知情同意书'
      }
    },
    //线下下单
    {
      path: '/orderun',
      name: 'orderun',
      component: () => import('./views/orderun/orderun.vue'),
      meta: {
        title: '订单确认'
      }
    },
    //线下微信支付信息
    {
      path: '/payun',
      name: 'payun',
      component: () => import('./views/orderun/payun.vue'),
      meta: {
        title: '支付页面'
      }
    },
	//活动详情页面
	{
	  path: '/detail/activity',
	  name:'activity',
	  component: () => import('./views/detail/activity/detail_act.vue'),
	  meta: {
	    title: ''
	  }
	},
	//客服页面
	{
	  path: '/kefu/kefu',
	  name:'kefu',
	  component: () => import('./views/kefu/kefu.vue'),
	  meta: {
	    title: '客服中心'
	  }
	},
	//客服页面2
	{
	  path: '/kefu/service.vue',
	  name:'service',
	  component: () => import('./views/kefu/service.vue'),
	  meta: {
	    title: '客服中心'
	  }
	},
	
 
 //评价成功
  { 
 	  path: '/evaluate',
    name: 'evaluate',
    component: () => import('./views/my/evaluate.vue'),
 },
  //评价成功跳转
  { 
 	  path: '/yes',
    name: 'yes',
    component: () => import('./views/my/yes.vue'),
 },

    //无匹配路由重定向到首页
    {
      path: "*",
      redirect: "/index"
    }
  ]
})
